export function bodyLock(lock) {
    if (iOS15()) {
        if (lock) {
            document.body.dataset.iosLock = true
        } else {
            document.body.removeAttribute('data-ios-lock')
        }
    } else {
        if (lock) {
            document.body.dataset.lock = true
        } else {
            document.body.removeAttribute('data-lock')
        }
    }
}

function iOS15() {
    return /iPhone OS 15/.test(navigator.userAgent)
    // return !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent)
}
